<template>
  <div class="container">
    <span class="title is-3">{{empresa.nombrec}}</span>
    <small class="title is-5">{{empresa.nit | textnumber()}}{{empresa.nit | dverif()}}</small>
    <small class="subtitle is-7">{{empresa.nombre}}</small>
    <hr />
    <div style="margin-top: 32px; margin-bottom:32px;">
      <button class="button is-medium is-light" @click="editable = true, create = true"><span class="icon is-small">
          <span class="material-icons">add_circle_outline</span>
        </span>
        <span>Crear Grupo</span></button>
    </div>
    <div>
      <p class="title">Grupos de inventario</p>
    </div>
    <div class="table-container" v-if="editable == false">
      <table class="table is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th>Código</th>
            <th>Nombre</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(inventaryGroup, index) in groups" :key="index">
          <tr>
            <th>{{inventaryGroup.codigo}}</th>
            <td style="display:flex; justify-content:space-between">{{inventaryGroup.descripcion}}</td>
            <td>
              <span class="icon has-text-info hand" @click="selectGroup(inventaryGroup)">
                <i class="material-icons">edit</i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr />
    <div class="columns" v-if="editable == true">
      <div class="column">
        <p class="title is-5">Código</p>
        <div>
          <input
            v-model="codigogroup"
            name="input-edit-code"
            id="input-edit-code"
            class="input is-medium"
            type="text"
            placeholder="Nuevo código"
          />
        </div>
      </div>
      <div class="column">
        <p class="title is-5">Nombre</p>
        <div>
          <input
            class="input is-medium"
            type="text"
            placeholder="Nuevo nombre"
            v-model="descripciongroup"
          />
        </div>
      </div>
    </div>
    <div class="columns" v-if="editable">
      <div class="column">
        <div class="buttons" style="margin-top:16px;">
          <button class="button is-medium is-info" v-if="create==true" v-on:click="createGroup()">
            <span class="icon is-small">
              <span class="material-icons">save</span>
            </span>
            <span>Guardar</span>
          </button>
          <button class="button is-medium is-info" v-if="create == false" v-on:click="editGroup()">
            <span class="icon is-small">
              <span class="material-icons">edit</span>
            </span>
            <span>Editar</span>
          </button>
          <button
            class="button is-medium"
            @click="editable = false, groupSelected = [], descripciongroup = '', codigogroup='', create = false, getProducts()"
          >Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      groups: [],
      editable: false,
      create: false,
      codigogroup: "",
      descripciongroup: "",
      groupSelected: {},
    };
  },
  computed: {
    ...mapState(["empresa", "productos"]),
  },
  methods: {
    selectGroup(inventarygroup) {
      this.editable = true;
      this.groupSelected = inventarygroup;
      this.descripciongroup = inventarygroup.descripcion;
      this.codigogroup = inventarygroup.codigo;
    },
    async createGroup() {
      try {
        let result;
        if (this.codigogroup !== "" && this.descripciongroup !== "") {
          result = await apiServices.post(`/creategroup`, {
            codigo: this.codigogroup,
            descripcion: this.descripciongroup,
          });
          if (result.data && result.data.message) {
            this.$store.dispatch("notify", {
              message: "El código ya se encuentra en la base de datos.",
              type: "is-danger",
            });
            this.getProducts();
          } else {
            this.getProducts();
            this.editable = false;
            this.create = false;
            this.groupSelected = [];
            this.descripciongroup = "";
            this.codigogroup = "";
            this.$store.dispatch("notify", {
              message: "Perfecto!. Grupo de inventario creado con éxito.",
            });
          }
        } else {
          this.$store.dispatch("notify", {
            message: "Llena todos los campos",
            type: "is-warning",
          });
          this.getProducts();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async editGroup() {
      try {
        let result;
        console.log("gruopselected", this.codigogroup)
        console.log("gruopselected", this.descripciongroup)
        if (this.codigogroup !== "" && this.descripciongroup !== "") {
          result = await apiServices.post(`/changegroup`, {
            id: this.groupSelected._id,
            codigo: this.codigogroup,
            descripcion: this.descripciongroup
          });
          if (result.data && result.data.message) {
            this.$store.dispatch("notify", {
              message: "El código ya se encuentra en la base de datos.",
              type: "is-danger",
            });
            this.getProducts();
          } else {
            this.editable = false;
            this.groupSelected = [];
            this.descripciongroup = "";
            this.codigogroup = "";
            this.getProducts();
            this.$store.dispatch("notify", {
              message: "Perfecto!.  Grupo de inventario editado con éxito.",
            });
          }
        } else {
          this.$store.dispatch("notify", {
            message: "Llena todos los campos",
            type: "is-warning"
          });
          this.getProducts();
        }
      } catch (err) {
        console.log("erroooorrrrr",err);
      }
    },
    async getProducts() {
      try {
        this.groups = [];
        const result = await apiServices.get(`/listgroup`);
        this.groups = functions.order(result.data, "codigo");
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.getProducts();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/inventorygroup/Inventorygroup.vue